<div class="basicrow f-black roboto-r f-reg m-top-ii text-center">
        <div class="shortcont">
            <div class="basicrow">
                <div class="basicrow">
                    <label class="label-f">
                        Nombre de la empresa
                    </label>

                    <input class="inp-f"  [(ngModel)]="this.name" readonly>
                </div>

                <div class="basicrow m-top-i">
                    <label class="label-f">
                        &#42; Teléfono de Contacto
                    </label>

                    <input class="inp-f" [(ngModel)]="this.cel"  maxlength="10">
                </div>

                <div class="basicrow m-top-i">
                    <label class="label-f">
                        &#42; Teléfono del Trabajo
                    </label>

                    <input class="inp-f" [(ngModel)]="this.homeNum"  maxlength="10">
                </div>
            </div>

            <div class="basicrow m-top-i">
                <div class="logline full"></div>
            </div>
            <div class="basicrow m-top-i text-center">
                <a  class="btns def-iv red centr vcenter" (click)="this.continueInfo2()">
                    <span class="tabcell" >
                        Guardar Cambios&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                    </span>
                </a>
            </div>
        
        </div>
    </div>